export type TEmailBuilderWorkspaceKind = "campaign" | "template";

export type TEmailBuilderWorkspace = {
  kind: TEmailBuilderWorkspaceKind;
  id: number;
};

export type TEmailBuilderLocationState = {
  returnTo?: string;
};

export function emailCampaignBuilderPath(campaignId: number): string {
  return `/admin/email-marketing/campaigns/${campaignId}/builder`;
}

export function emailCampaignSelectTemplatePath(campaignId: number): string {
  return `/admin/email-marketing/campaigns/${campaignId}/new?step=3`;
}

export function emailTemplateBuilderPath(templateId: number): string {
  return `/admin/email-marketing/templates/${templateId}/builder`;
}

export function emailTemplateLibraryPath(): string {
  return "/admin/email-marketing/templates";
}

export function emailMarketingCampaignsPath(): string {
  return "/admin/email-marketing";
}

export function emailMarketingSmartListsTabPath(): string {
  return "/admin/email-marketing/smart-lists";
}

export function emailMarketingSettingsTabPath(): string {
  return "/admin/email-marketing/settings";
}

export function isEmailMarketingTabPath(pathname: string): boolean {
  return (
    pathname === emailMarketingCampaignsPath() ||
    pathname === emailTemplateLibraryPath() ||
    pathname === emailMarketingSmartListsTabPath() ||
    pathname === emailMarketingSettingsTabPath()
  );
}

export function emailCampaignBuilderReturnPath(
  campaignId: number,
  source: "create" | "edit",
): string {
  if (source === "create") {
    return `/admin/email-marketing/campaigns/${campaignId}/new?step=2`;
  }

  return `/admin/email-marketing/campaigns/${campaignId}`;
}

export function resolveEmailBuilderReturnTo(
  workspace: TEmailBuilderWorkspace,
  locationState: unknown,
): string {
  if (typeof locationState === "object" && locationState !== null) {
    const returnTo = (locationState as TEmailBuilderLocationState).returnTo;
    if (typeof returnTo === "string" && returnTo.length > 0) {
      return returnTo;
    }
  }

  if (workspace.kind === "template") {
    return emailTemplateLibraryPath();
  }

  return emailCampaignBuilderReturnPath(workspace.id, "edit");
}

export function isEmailBuilderTemplateRoute(pathname: string): boolean {
  return /^\/admin\/email-marketing\/templates\/[^/]+\/builder$/.test(pathname);
}

export function isEmailBuilderCampaignRoute(pathname: string): boolean {
  return /^\/admin\/email-marketing\/campaigns\/[^/]+\/builder$/.test(pathname);
}
